<!-- Label of a field of the video dialog's second tab (SeoPanel.vue): the name on the left (default slot, may hold a
     "(optional)" span), on the right what the slot `extra` holds (counter and copy button, "Find ideas"…). -->
<template>
  <label class="flex items-center justify-between text-xs font-bold text-gray-400 mb-2 tracking-wider"><span><slot /></span><slot name="extra" /></label>
</template>
